import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationContainer, NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import logo from "assets/images/vibo_vibo-magenta-transparent.png";
import { Form, FormGroup, Input } from "reactstrap";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress";
import * as actions from "actions";
import ResetPasswordModal from "../ResetPasswordModal";
import {isWebview} from '../../util/generalFunction';

import store from '../../store/'
class Login extends Component {
  state = {
    modal: false,
  };

  toggle = () => {
    // console.log("TOGGLE");
    // this.setState({
    //   modal: !this.state.modal,
    // });
    this.props.forgotPasswordSuccess(false)
  };
  handleModal = () => {
    console.log("IN HANDLE MODAL", this.props);
    if (this.props.emailsent) {
      this.toggle();
    }
  };

  componentDidMount() {
    console.log("I MOUNT");
    this.props.changeVerify();
    const user = JSON.parse(localStorage.getItem("user-data"));

    if (user) {
      const checked =
        // eslint-disable-next-line no-nested-ternary
        this.props.initURL.indexOf("/admin") !== -1
          ? this.props.initURL
          : user.role.name === "Administrator" && isWebview()
          ? "/SuperAdminMobileScreen"
          : user.role.name === "Administrator"
          ? "/super-admin/businesses"
          : user.role.name === "Customer"
          ? "/"
          : user.role.name === "Public"
          ? "/access-denied"
          : "/admin/appointments";

      this.props.history.push(checked);
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    const user = JSON.parse(localStorage.getItem("user-data"));

    if (user) {
      const checked =
        // eslint-disable-next-line no-nested-ternary
        this.props.initURL.indexOf("/admin") !== -1
          ? this.props.initURL
          : user.role.name === "Administrator" && isWebview()
          ? "/SuperAdminMobileScreen"
          : user.role.name === "Administrator"
          ? "/super-admin/businesses"
          : user.role.name === "Customer"
          ? "/"
          : user.role.name === "Public"
          ? "/access-denied"
          : "/admin/appointments";

      this.props.history.push(checked);
    }
  }

  render() {
    console.log("I RENDERED", this.props.emailsent);

    
    // {
    //   this.props.emailsent ? this.toggle : null;
    // }
    document.body.classList.remove("ios-mobile-view-height");
    const { email, password, loader, showMessage, alertMessage, verify, emailsent } = this.props;
    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header border-bottom">
          {isWebview() ? localStorage.getItem("isAdmin") == "true"
            ? (
              <div className="app-logo">
                <img src={logo} alt="jambo" title="Vibo Vibo" />
              </div>
            )
            : (
              <Link className="app-logo" to="/" title="Jambo">
                <img src={logo} alt="jambo" title="Vibo Vibo" />
              </Link>
            ) :
            <Link className="app-logo" to="/" title="Jambo">
                <img src={logo} alt="jambo" title="Vibo Vibo" />
              </Link>
            }
          </div>
          <h2 className="text-center mb-4">Forgot Password</h2>
          <div className="login-form">
            <Form
              noValidate
              onSubmit={e => {
                e.preventDefault();
                if (!email) {
                  NotificationManager.error("Please Enter Email");
                } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                  NotificationManager.error("Please enter a valid email");
                }
                if (email) {
                  this.props.userForgot({ email });
                  this.props.showLoader();
                }
              }}
            >
              <p className="text-center mb-4">Please provide your email address, and if an account is registered with us, we will email you a link to reset your password.</p>
              <FormGroup className="mb-4">
                <Input
                  type="email"
                  name="email"
                  id="exampleEmail"
                  placeholder="Email"
                  value={email}
                  onChange={event => this.props.userEmail(event.target.value)}
                />
              </FormGroup>

              {/* <div className="mt-1 mb-2 text-center">
                <Link
                  to=""
                  title="Reset Password"
                  style={{ color: "#a90087", textDecoration: "underline" }}
                >
                  <IntlMessages id="appModule.forgotPassword" />
                </Link>
              </div> */}
              <div className="mt-1 mb-2 text-center">
                <Link to="/login" title="Login">
                  <IntlMessages id="vibo.component.login.loginText" />
                </Link>
              </div>
              <div className="mt-3 mb-2 text-center">
                {loader ? (
                  <CircularProgress />
                ) : (
                  <button
                    // style={{ backgroundColor: "#EA33A6", color: "#fff" }}
                    className="btn btn-vibo2"
                    type="submit"
                    onClick={this.handleModal}
                  >
                    <IntlMessages id="sidebar.appModule.forgotPassword" />
                  </button>
                )}
              </div>

              {/* <div className="mt-1 mb-2 text-center">
                <IntlMessages id="component.login.dontHaveAnAccountText" />
                <Link
                to=""
                title="Reset Password"
                style={{ color: "#a90087", textDecoration: "underline" }}
                >
                <IntlMessages id="appModule.signup" />
                </Link>
              </div> */}
            </Form>
          </div>
          <ResetPasswordModal modal={this.props.emailsent} toggle={this.toggle} />
        </div>

        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ login, auth }) => {
  const { email, password, loader, showMessage, alertMessage, verify, user, emailsent } = login;
  const { initURL } = auth;
  return { email, password, loader, showMessage, alertMessage, verify, user, emailsent, initURL };
};

const mapDispatchToProps = dispatch => ({
  userForgot: payload => dispatch(actions.forgotPassword(payload)),
  userEmail: email => dispatch(actions.emailInput(email)),
  showLoader: () => dispatch(actions.showLoader()),
  hideLoader: () => dispatch(actions.hideLoader()),
  // forgotPasswordSuccess: () => dispatch(actions.forgotPasswordSuccess()),
  hideMessage: () => dispatch(actions.hideMessages()),
  changeVerify: payload => dispatch(actions.changeVerify(payload)),
  forgotPasswordSuccess: payload=> dispatch(actions.forgotPasswordSuccess(payload))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);



// WEBPACK FOOTER //
// ./components/ForgotPassword/index.js